export default "/images/1c2b66a3389c66db906f5e26825ccf41.avif";